export const buildFirstInstallmentOptions = (now = new Date()) => {
  const base = new Date(now.getFullYear(), now.getMonth(), 1);
  const minOffset = -24;
  const maxOffset = 24;
  const formatter = new Intl.DateTimeFormat('es-MX', {
    month: 'long',
    year: 'numeric',
  });

  return Array.from({ length: maxOffset - minOffset + 1 }, (_, index) => {
    const offset = minOffset + index;
    const date = new Date(base.getFullYear(), base.getMonth() + offset, 1);
    const year = date.getFullYear();
    const month = `${date.getMonth() + 1}`.padStart(2, '0');
    const rawLabel = formatter.format(date);
    const label = rawLabel.charAt(0).toUpperCase() + rawLabel.slice(1);

    return {
      value: `${year}-${month}`,
      label,
      meta: {
        year,
        month: Number(month),
      },
    };
  });
};
